import { AuthState, AuthTypes } from 'redux/actions/auth/auth.d';
import { STORE_AUTH_DATA } from 'redux/actionTypes/authUser';

const INITIAL_STATE: AuthState = {
  data: {
    uid: 0,
    empname: '',
    gender: '',
    dob: '',
    mobile: 0,
    mailid: '',
    category: '',
    role: '',
  },
  submitted: false,
  success: false,
};

function authReducer(state = INITIAL_STATE, action: AuthTypes): AuthState {
  switch (action.type) {
    case STORE_AUTH_DATA: {
      return {
        ...state,
        data: { ...action.payload },
        submitted: false,
        success: true,
      };
    }
    default:
      return state;
  }
}

export default authReducer;
